;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import Link from 'next/link';
import { ModalHeader, Modal, ModalBody, Row, Col } from 'reactstrap';
import { MdCheck } from 'react-icons/md';
import Login from './auth/Login';
import { getI18nUtils } from '../i18n/i18n-utils';
import { useParams } from 'next/navigation';
import { Locale } from '../i18n/i18n-config';

type Props = {
  isOpen?: boolean;
  toggle: () => void;
  dictionary: Record<string, string>;
};
const LoginModal = ({ isOpen = true, toggle, dictionary }: Props): JSX.Element => {
  const { formatMessage } = getI18nUtils(dictionary);
  const { locale }: { locale: Locale } = useParams();

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl">
      <ModalHeader toggle={toggle}>{formatMessage({ id: 'login-h1' })}</ModalHeader>
      <ModalBody className="my-3">
        <Row>
          <Col xs={12} lg={{ size: 6, order: 2 }}>
            <h4 className="mb-5">{formatMessage({ id: 'have_account' })}</h4>
            <Login dictionary={dictionary} locale={locale} />
          </Col>
          <Col xs={12} lg={{ size: 6, order: 1 }}>
            <h4 className="mb-5">{formatMessage({ id: 'create_account' })}</h4>
            <div className="d-flex justify-content-start align-items-start mb-3">
              <MdCheck size="20" className="check-icon me-3" />
              <div className="feature-text">{formatMessage({ id: 'mysynergy_argument_favorite_jobs' })}</div>
            </div>
            <div className="text-wrap d-flex justify-content-start align-items-start mb-3">
              <MdCheck size="20" className="check-icon me-3" />
              <div className="feature-text">{formatMessage({ id: 'mysynergy_argument_saved_searches' })}</div>
            </div>
            <div className="d-flex justify-content-start align-items-start mb-3">
              <MdCheck size="20" className="check-icon me-3" />
              <div className="feature-text">{formatMessage({ id: 'mysynergy_argument_job_suggestions' })}</div>
            </div>
            <div className="d-flex justify-content-start align-items-start mb-5">
              <MdCheck size="20" className="check-icon me-3" />
              <div className="feature-text">{formatMessage({ id: 'mysynergy_argument_application_followup' })}</div>
            </div>
            <Link href="/auth/signup/" className="text-dark">
              {formatMessage({ id: 'signup' })}
            </Link>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default LoginModal;
